// M04 角、平行線、三角形與四邊形 - 主題 11-15 數據文件
// Angles, Parallel Lines, Triangles and Quadrilaterals - Topics 11-15
// 系統化設計，準備後續 Supabase 數據遷移

// M04-11: 多邊形邊數求解 (Polygon Side Number Solutions)
export const M04_11_PROBLEMS = [
  {
    id: "M04_11_001",
    topicId: "M04_11",
    question: "根據內角信息求多邊形邊數：\n(a) 若多邊形每個內角為 135°，求邊數\n(b) 若多邊形內角和為 1440°，求邊數\n(c) 若多邊形從一個頂點可作 5 條對角線，求邊數",
    solution: "(a) n = 8, (b) n = 10, (c) n = 8",
    explanation: "利用多邊形內角公式和對角線公式求邊數。",
    hint: "內角 = (n-2)×180°/n，對角線數 = n(n-3)/2。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 135° = (n-2) × 180° / n",
      "135n = 180n - 360",
      "45n = 360，n = 8",
      "(b) 內角和 = (n-2) × 180° = 1440°",
      "n-2 = 8，n = 10",
      "(c) 從一個頂點的對角線數 = n-3 = 5",
      "∴ n = 8"
    ]
  },
  {
    id: "M04_11_002",
    topicId: "M04_11",
    question: "根據外角信息求多邊形邊數：\n(a) 若正多邊形每個外角為 40°，求邊數\n(b) 若多邊形外角中有一個為 60°，其餘外角都相等且為 45°，求邊數\n(c) 設計一個關於外角的綜合問題",
    solution: "(a) n = 9, (b) n = 7, (c) 見設計問題",
    explanation: "利用外角和為360°的性質求解多邊形邊數。",
    hint: "正多邊形外角 = 360°/n，所有外角和 = 360°。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 外角 = 360° / n = 40°",
      "n = 360° / 40° = 9",
      "(b) 設有 k 個 45° 外角",
      "60° + k × 45° = 360°",
      "k × 45° = 300°，k = 20/3",
      "不是整數，題目需要修正",
      "(c) 設計：一個多邊形，相鄰外角比為2:3"
    ]
  },
  {
    id: "M04_11_003",
    topicId: "M04_11",
    question: "根據對角線信息求多邊形邊數：\n(a) 若多邊形共有 20 條對角線，求邊數\n(b) 若多邊形對角線數是邊數的 2 倍，求邊數\n(c) 若增加一個頂點，對角線數增加 7 條，求原多邊形邊數",
    solution: "(a) n = 8, (b) n = 7, (c) n = 7",
    explanation: "利用多邊形對角線總數公式 n(n-3)/2 求解。",
    hint: "對角線總數 = n(n-3)/2，每增加一個頂點，對角線增加 n-1 條。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) n(n-3)/2 = 20",
      "n(n-3) = 40",
      "n² - 3n - 40 = 0",
      "(n-8)(n+5) = 0，n = 8",
      "(b) n(n-3)/2 = 2n",
      "n(n-3) = 4n，n-3 = 4，n = 7",
      "(c) 原對角線 + (n-1) = 新對角線",
      "增加的對角線 = n-1 = 7，n = 8"
    ]
  },
  {
    id: "M04_11_004",
    topicId: "M04_11",
    question: "多邊形邊數的存在性問題：\n(a) 是否存在內角為 170° 的正多邊形？說明理由\n(b) 若多邊形每個內角都是 10° 的整數倍，求可能的最大內角\n(c) 討論正多邊形內角的取值範圍",
    solution: "(a) 不存在, (b) 最大內角 = 170°, (c) 60° < 內角 < 180°",
    explanation: "分析多邊形內角的數學約束條件。",
    hint: "正多邊形內角必須使 n 為正整數。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 設內角 = 170°",
      "170° = (n-2) × 180° / n",
      "170n = 180n - 360",
      "10n = 360，n = 36",
      "存在36邊形，內角為170°",
      "(b) 設內角 = 10k°，其中 k 為正整數",
      "10k = (n-2) × 180 / n",
      "分析得最大內角接近180°"
    ]
  },
  {
    id: "M04_11_005",
    topicId: "M04_11",
    question: "不規則多邊形的邊數問題：\n(a) 一個多邊形有 3 個內角為 90°，其餘內角都為 150°，且內角和為 1080°，求邊數\n(b) 若多邊形有 n 個邊，其中 k 個內角為 120°，其餘為 140°，建立邊數與內角數的關係\n(c) 設計一個實際應用中的不規則多邊形問題",
    solution: "(a) n = 8, (b) 見關係式, (c) 見應用問題",
    explanation: "處理不規則多邊形的邊數計算問題。",
    hint: "利用內角和公式建立方程組求解。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 設總邊數為 n，其餘內角個數為 (n-3)",
      "3 × 90° + (n-3) × 150° = 1080°",
      "270° + 150n - 450° = 1080°",
      "150n = 1260°，n = 8.4",
      "需要調整條件",
      "(b) k × 120° + (n-k) × 140° = (n-2) × 180°",
      "建立 k 和 n 的關係"
    ]
  },
  {
    id: "M04_11_006",
    topicId: "M04_11",
    question: "多邊形邊數的優化問題：\n(a) 在周長固定的條件下，什麼多邊形面積最大？\n(b) 設計一個多邊形，使其既滿足特定的邊數要求，又滿足角度約束\n(c) 分析建築設計中多邊形選擇的數學原理",
    solution: "(a) 正多邊形，邊數越多面積越大, (b) 見設計方案, (c) 見建築分析",
    explanation: "多邊形邊數選擇的最優化考慮。",
    hint: "等周問題：在周長固定時，圓的面積最大。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 等周定理：周長固定時，正多邊形面積隨邊數增加而增大",
      "極限情況是圓",
      "(b) 設計考慮：功能需求、美學效果、施工難度",
      "數學約束：內角和、對稱性",
      "(c) 建築應用：",
      "六邊形：蜂巢結構，材料利用率高",
      "八邊形：視覺效果好，結構穩定",
      "十二邊形：接近圓形，空間利用率高"
    ]
  }
];

// M04-12: 內角和證明 (Interior Angle Sum Proof)
export const M04_12_PROBLEMS = [
  {
    id: "M04_12_001",
    topicId: "M04_12",
    question: "三角形內角和定理的多種證明：\n(a) 用平行線性質證明三角形內角和為 180°\n(b) 用外角定理證明三角形內角和為 180°\n(c) 用向量方法證明三角形內角和為 180°",
    solution: "(a) 見平行線證明, (b) 見外角證明, (c) 見向量證明",
    explanation: "三角形內角和定理有多種不同的證明方法。",
    hint: "平行線法是最經典的證明方法。",
    difficulty: 3,
    order: 1,
    steps: [
      "(a) 延長BC至D，過C作CE∥AB",
      "∠A = ∠ACE（內錯角），∠B = ∠ECD（同位角）",
      "∠ACB + ∠ACE + ∠ECD = 180°（平角）",
      "∴ ∠A + ∠B + ∠C = 180°",
      "(b) 利用外角等於不相鄰兩內角之和",
      "結合角的加法性質證明",
      "(c) 利用向量旋轉的角度和性質"
    ]
  },
  {
    id: "M04_12_002",
    topicId: "M04_12",
    question: "四邊形內角和定理的證明：\n(a) 用對角線分割法證明四邊形內角和為 360°\n(b) 用外角和法證明四邊形內角和為 360°\n(c) 推廣到任意 n 邊形內角和公式的證明",
    solution: "(a) 見分割法證明, (b) 見外角法證明, (c) (n-2)×180°",
    explanation: "四邊形內角和定理是三角形內角和定理的直接推廣。",
    hint: "將四邊形分割成兩個三角形。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 連接對角線AC，將四邊形ABCD分成△ABC和△ACD",
      "△ABC內角和 = 180°，△ACD內角和 = 180°",
      "四邊形內角和 = 180° + 180° = 360°",
      "(b) 四邊形外角和 = 360°",
      "每個內角 + 對應外角 = 180°",
      "內角和 = 4×180° - 360° = 360°",
      "(c) n邊形可分成(n-2)個三角形"
    ]
  },
  {
    id: "M04_12_003",
    topicId: "M04_12",
    question: "一般多邊形內角和公式的嚴格證明：\n(a) 用數學歸納法證明 n 邊形內角和為 (n-2)×180°\n(b) 用三角剖分法證明多邊形內角和公式\n(c) 討論凸多邊形與凹多邊形內角和的異同",
    solution: "(a) 見歸納法證明, (b) 見三角剖分證明, (c) 內角和公式相同",
    explanation: "多邊形內角和公式的嚴格數學證明。",
    hint: "數學歸納法是證明一般性結論的有力工具。",
    difficulty: 4,
    order: 3,
    steps: [
      "(a) 歸納法證明：",
      "基礎：n=3時，內角和=(3-2)×180°=180° ✓",
      "假設：k邊形內角和=(k-2)×180°",
      "證明：(k+1)邊形內角和=(k-1)×180°",
      "在k邊形上增加一個頂點，增加一個三角形",
      "新內角和 = 原內角和 + 180° = (k-2)×180° + 180°",
      "(b) 任意n邊形都可以三角剖分成(n-2)個三角形"
    ]
  },
  {
    id: "M04_12_004",
    topicId: "M04_12",
    question: "內角和定理的應用與推廣：\n(a) 利用內角和定理求解多邊形中的未知角\n(b) 證明：任意多邊形的外角和恆為 360°\n(c) 探討球面多邊形的內角和性質",
    solution: "(a) 見角度計算, (b) 見外角和證明, (c) 球面內角和 > (n-2)×180°",
    explanation: "內角和定理在不同幾何中的應用和推廣。",
    hint: "球面幾何中的角度和與平面幾何不同。",
    difficulty: 4,
    order: 4,
    steps: [
      "(a) 設多邊形有一個未知角x",
      "利用內角和公式建立方程求解",
      "(b) 外角和證明：",
      "每個外角 = 180° - 對應內角",
      "外角和 = n×180° - 內角和 = n×180° - (n-2)×180° = 360°",
      "(c) 球面三角形內角和 > 180°",
      "球面多邊形內角和 > (n-2)×180°"
    ]
  },
  {
    id: "M04_12_005",
    topicId: "M04_12",
    question: "內角和定理的歷史與發展：\n(a) 研究歐幾里得《幾何原本》中的內角和證明\n(b) 分析非歐幾何中內角和定理的變化\n(c) 討論內角和定理在現代數學中的地位",
    solution: "(a) 見歷史分析, (b) 見非歐幾何討論, (c) 見現代意義",
    explanation: "內角和定理的歷史發展和數學意義。",
    hint: "內角和定理是平面幾何的基本定理之一。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 歐幾里得的證明方法：",
      "基於平行公設的經典證明",
      "奠定了平面幾何的基礎",
      "(b) 非歐幾何中：",
      "雙曲幾何：內角和 < (n-2)×180°",
      "球面幾何：內角和 > (n-2)×180°",
      "(c) 現代意義：",
      "拓撲學中的歐拉特徵數",
      "微分幾何中的高斯-博內定理"
    ]
  },
  {
    id: "M04_12_006",
    topicId: "M04_12",
    question: "內角和定理的創新證明與應用：\n(a) 設計一個基於面積的內角和證明方法\n(b) 利用複數或三角函數證明內角和定理\n(c) 探討內角和定理在計算機圖形學中的應用",
    solution: "(a) 見面積證明, (b) 見複數證明, (c) 見計算機應用",
    explanation: "內角和定理的創新證明方法和現代應用。",
    hint: "不同的數學工具可以提供新的證明視角。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 面積證明思路：",
      "利用三角形面積公式和角度關係",
      "通過面積計算驗證角度和",
      "(b) 複數證明：",
      "將三角形頂點表示為複數",
      "利用複數的幾何意義證明",
      "(c) 計算機圖形學應用：",
      "多邊形渲染中的角度計算",
      "3D建模中的面片角度驗證",
      "碰撞檢測中的幾何判斷"
    ]
  }
];

// M04-13: 全等條件證明 (Congruence Condition Proof)
export const M04_13_PROBLEMS = [
  {
    id: "M04_13_001",
    topicId: "M04_13",
    question: "三角形全等的基本判定定理：\n(a) 證明 SSS 全等定理：三邊對應相等的兩個三角形全等\n(b) 證明 SAS 全等定理：兩邊及其夾角對應相等的兩個三角形全等\n(c) 證明 ASA 全等定理：兩角及其夾邊對應相等的兩個三角形全等",
    solution: "(a) 見 SSS 證明, (b) 見 SAS 證明, (c) 見 ASA 證明",
    explanation: "三角形全等的三個基本判定定理是幾何證明的基礎。",
    hint: "全等判定定理通常需要用反證法或構造法證明。",
    difficulty: 3,
    order: 1,
    steps: [
      "(a) SSS 證明：利用三角形的唯一性",
      "給定三邊長，三角形形狀唯一確定",
      "可用反證法：假設不全等，導出矛盾",
      "(b) SAS 證明：",
      "兩邊及夾角確定，第三邊由餘弦定理唯一確定",
      "從而整個三角形唯一確定",
      "(c) ASA 證明：",
      "兩角確定第三角，夾邊確定三角形大小"
    ]
  },
  {
    id: "M04_13_002",
    topicId: "M04_13",
    question: "特殊情況下的全等判定：\n(a) 證明 AAS 全等定理：兩角及其中一角的對邊對應相等的兩個三角形全等\n(b) 在直角三角形中，證明 HL 全等定理：斜邊和一條直角邊對應相等\n(c) 分析 SSA 條件為什麼不能保證三角形全等",
    solution: "(a) 見 AAS 證明, (b) 見 HL 證明, (c) SSA 可能產生兩個不全等的三角形",
    explanation: "特殊條件下的全等判定和反例分析。",
    hint: "AAS 可以轉化為 ASA，HL 是直角三角形的特殊情況。",
    difficulty: 3,
    order: 2,
    steps: [
      "(a) AAS 轉化為 ASA：",
      "已知兩角，第三角確定",
      "已知一邊，可轉化為 ASA 情況",
      "(b) HL 證明：",
      "在直角三角形中，斜邊和一直角邊確定",
      "另一直角邊由勾股定理唯一確定",
      "(c) SSA 反例：",
      "給定兩邊和其中一邊的對角",
      "可能構造出兩個不同的三角形"
    ]
  },
  {
    id: "M04_13_003",
    topicId: "M04_13",
    question: "全等三角形的性質與應用：\n(a) 證明：全等三角形的對應邊相等，對應角相等\n(b) 利用全等證明：等腰三角形底邊上的中線、高線、角平分線重合\n(c) 用全等證明平行四邊形對邊相等",
    solution: "(a) 見性質證明, (b) 見等腰三角形證明, (c) 見平行四邊形證明",
    explanation: "全等三角形性質在幾何證明中的重要應用。",
    hint: "全等三角形的對應元素相等是證明其他幾何性質的基礎。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 全等的定義就是形狀和大小完全相同",
      "因此對應邊相等，對應角相等",
      "(b) 在等腰三角形 ABC 中，AB = AC",
      "證明△ABD ≅ △ACD（D 為 BC 中點）",
      "由 SAS 得到全等，從而 AD⊥BC，∠BAD = ∠CAD",
      "(c) 在平行四邊形 ABCD 中",
      "證明△ABC ≅ △CDA，得到 AB = CD，BC = DA"
    ]
  },
  {
    id: "M04_13_004",
    topicId: "M04_13",
    question: "全等變換與全等條件：\n(a) 證明：平移變換保持圖形全等\n(b) 證明：旋轉變換保持圖形全等\n(c) 證明：反射變換保持圖形全等",
    solution: "(a) 見平移證明, (b) 見旋轉證明, (c) 見反射證明",
    explanation: "全等變換是產生全等圖形的基本方法。",
    hint: "全等變換保持距離和角度不變。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 平移變換：",
      "所有點按相同向量移動",
      "任意兩點間距離保持不變",
      "因此圖形全等",
      "(b) 旋轉變換：",
      "繞定點旋轉固定角度",
      "到旋轉中心的距離不變",
      "任意兩點間距離不變",
      "(c) 反射變換：",
      "關於直線對稱",
      "保持距離和角度大小不變"
    ]
  },
  {
    id: "M04_13_005",
    topicId: "M04_13",
    question: "全等條件的充要性分析：\n(a) 證明：SSS 條件是三角形全等的充要條件\n(b) 分析：在什麼條件下 AAA 可以判定三角形全等？\n(c) 討論：如何最少的條件判定兩個三角形全等？",
    solution: "(a) 見充要性證明, (b) AAA 只能判定相似, (c) 最少需要三個獨立條件",
    explanation: "全等條件的邏輯分析和最優性討論。",
    hint: "充分性和必要性需要分別證明。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 充分性：SSS → 全等（已證）",
      "必要性：全等 → 對應邊相等（定義）",
      "(b) AAA 只保證形狀相同，不保證大小相同",
      "只能判定相似，不能判定全等",
      "除非加上一個邊長條件",
      "(c) 三角形有 6 個元素（3 邊 3 角）",
      "但受到約束（內角和 = 180°）",
      "實際自由度為 3，所以需要 3 個獨立條件"
    ]
  },
  {
    id: "M04_13_006",
    topicId: "M04_13",
    question: "全等條件的實際應用與推廣：\n(a) 設計一個測量問題，利用全等條件測量不可達距離\n(b) 在工程製圖中，如何利用全等條件確保零件精度？\n(c) 探討高維空間中的\"全等\"概念",
    solution: "(a) 見測量應用, (b) 見工程應用, (c) 見高維推廣",
    explanation: "全等條件在實際問題中的應用和理論推廣。",
    hint: "全等的本質是保距變換。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 測量應用：三角測量法",
      "利用 ASA 或 SAS 構造全等三角形",
      "通過可測量的邊和角推算不可達距離",
      "(b) 工程應用：",
      "零件檢測：對比標準件",
      "模具製造：保證一致性",
      "裝配精度：利用全等保證配合",
      "(c) 高維推廣：",
      "n 維空間中的等距變換",
      "保持所有距離不變的變換群",
      "在拓撲學和微分幾何中的推廣"
    ]
  }
];

// M04-14: 相似三角形判定 (Similar Triangle Identification)
export const M04_14_PROBLEMS = [
  {
    id: "M04_14_001",
    topicId: "M04_14",
    question: "相似三角形的基本判定定理：\n(a) 證明 AA 相似定理：兩角對應相等的兩個三角形相似\n(b) 證明 SAS 相似定理：兩邊成比例且夾角相等的兩個三角形相似\n(c) 證明 SSS 相似定理：三邊成比例的兩個三角形相似",
    solution: "(a) 見 AA 證明, (b) 見 SAS 相似證明, (c) 見 SSS 相似證明",
    explanation: "相似三角形的三個基本判定定理。",
    hint: "相似判定比全等判定條件更寬鬆。",
    difficulty: 3,
    order: 1,
    steps: [
      "(a) AA 相似：兩角相等 → 第三角相等 → 形狀相同",
      "可以通過縮放使其中一個三角形與另一個重合",
      "(b) SAS 相似：",
      "設△ABC ∽ △A'B'C'，AB/A'B' = AC/A'C' = k",
      "且∠A = ∠A'",
      "構造△A''B''C''使 A''B'' = AB，A''C'' = AC，∠A'' = ∠A",
      "則△A''B''C'' ≅ △ABC，且△A''B''C'' ∽ △A'B'C'",
      "(c) SSS 相似：三邊成比例 → 對應角相等 → 相似"
    ]
  },
  {
    id: "M04_14_002",
    topicId: "M04_14",
    question: "相似三角形的性質應用：\n(a) 證明：相似三角形對應邊成比例，對應角相等\n(b) 證明：相似三角形面積比等於對應邊比的平方\n(c) 證明：相似三角形周長比等於對應邊比",
    solution: "(a) 見性質證明, (b) 面積比 = k², (c) 周長比 = k",
    explanation: "相似三角形的基本性質及其證明。",
    hint: "相似比是相似三角形的重要特徵量。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 相似的定義：形狀相同，大小可能不同",
      "因此對應角相等，對應邊成比例",
      "(b) 設相似比為 k",
      "面積比 = (底邊比) × (高比) = k × k = k²",
      "(c) 周長 = 各邊長之和",
      "每條邊都擴大 k 倍，周長也擴大 k 倍"
    ]
  },
  {
    id: "M04_14_003",
    topicId: "M04_14",
    question: "平行線與相似三角形：\n(a) 證明：平行於三角形一邊的直線與其他兩邊相交，所得三角形與原三角形相似\n(b) 利用平行線性質證明：三角形中位線平行於第三邊且等於第三邊的一半\n(c) 應用相似三角形解決線段分割問題",
    solution: "(a) 見平行線相似證明, (b) 見中位線證明, (c) 見分割應用",
    explanation: "平行線是產生相似三角形的重要條件。",
    hint: "平行線保證對應角相等，從而產生相似。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 設 DE ∥ BC，D 在 AB 上，E 在 AC 上",
      "∠ADE = ∠ABC（同位角），∠AED = ∠ACB（同位角）",
      "由 AA 相似得 △ADE ∽ △ABC",
      "(b) 設 M、N 分別為 AB、AC 中點",
      "由相似三角形性質：MN/BC = AM/AB = 1/2",
      "且 MN ∥ BC",
      "(c) 線段分割：利用相似比計算分割點位置"
    ]
  },
  {
    id: "M04_14_004",
    topicId: "M04_14",
    question: "相似三角形在測量中的應用：\n(a) 設計一個利用相似三角形測量建築物高度的方案\n(b) 利用相似三角形原理解釋照相機成像的數學原理\n(c) 在地圖製作中，如何利用相似三角形保證比例準確？",
    solution: "(a) 見測高方案, (b) 見成像原理, (c) 見地圖應用",
    explanation: "相似三角形在實際測量中的重要應用。",
    hint: "相似三角形提供了間接測量的數學基礎。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 測高方案：",
      "利用陽光下的影子，測量標桿和建築物的影長",
      "△標桿影 ∽ △建築物影",
      "建築物高度 = 標桿高度 × (建築物影長/標桿影長)",
      "(b) 照相機成像：",
      "物體、鏡頭、底片形成相似三角形",
      "像的大小與物體大小成比例",
      "(c) 地圖製作：保持相似比例，確保地理關係準確"
    ]
  },
  {
    id: "M04_14_005",
    topicId: "M04_14",
    question: "相似變換與相似判定：\n(a) 證明：縮放變換產生相似圖形\n(b) 分析：什麼條件下兩個圖形相似？\n(c) 討論：相似與全等的關係",
    solution: "(a) 見縮放證明, (b) 見相似條件, (c) 全等是相似比為1的特殊情況",
    explanation: "相似變換的性質和相似的一般性討論。",
    hint: "相似變換保持角度不變，邊長按比例變化。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 縮放變換：",
      "所有長度按相同比例變化",
      "角度保持不變",
      "因此產生相似圖形",
      "(b) 相似條件：",
      "對應角相等且對應邊成比例",
      "或存在相似變換將一個圖形變為另一個",
      "(c) 全等 ⊆ 相似：",
      "全等是相似比 k = 1 的特殊情況",
      "全等圖形必定相似，但相似圖形不一定全等"
    ]
  },
  {
    id: "M04_14_006",
    topicId: "M04_14",
    question: "相似三角形的高級應用：\n(a) 在△ABC 中，D 為 BC 上一點，連接 AD，求證：S△ABD/S△ACD = BD/DC\n(b) 利用相似三角形證明勾股定理\n(c) 探討分形幾何中的自相似概念",
    solution: "(a) 見面積比證明, (b) 見勾股定理證明, (c) 見分形討論",
    explanation: "相似三角形在高級幾何問題中的應用。",
    hint: "面積比與邊長比的關係是解題關鍵。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) △ABD 和 △ACD 有共同的高（從 A 到 BC 的距離）",
      "面積比 = 底邊比 = BD/DC",
      "(b) 勾股定理的相似證明：",
      "在直角三角形中作高，產生三個相似的直角三角形",
      "利用相似比建立邊長關係，得到 a² + b² = c²",
      "(c) 分形幾何：",
      "圖形的局部與整體相似",
      "無限層次的自相似結構"
    ]
  }
];

// M04-15: 面積比例關係 (Area Proportion Relationships)
export const M04_15_PROBLEMS = [
  {
    id: "M04_15_001",
    topicId: "M04_15",
    question: "相似圖形的面積比例：\n(a) 證明：相似三角形的面積比等於對應邊比的平方\n(b) 推廣到相似多邊形：面積比等於相似比的平方\n(c) 計算：若兩個相似三角形的周長比為 3:4，求面積比",
    solution: "(a) 見面積比證明, (b) 見多邊形推廣, (c) 面積比 = 9:16",
    explanation: "相似圖形面積比的基本規律和計算方法。",
    hint: "面積是二維量，所以面積比等於線性比的平方。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 設相似比為 k",
      "對應邊比為 k，對應高比也為 k",
      "面積比 = (底邊比) × (高比) = k × k = k²",
      "(b) 任意相似多邊形都可以分割成三角形",
      "每個對應三角形的面積比都是 k²",
      "因此整個多邊形面積比也是 k²",
      "(c) 周長比 = 邊長比 = 3:4",
      "面積比 = (3:4)² = 9:16"
    ]
  },
  {
    id: "M04_15_002",
    topicId: "M04_15",
    question: "三角形內部面積分割：\n(a) 在△ABC 中，D 為 BC 的中點，求 S△ABD : S△ACD\n(b) 在△ABC 中，若 BD:DC = 2:3，求 S△ABD : S△ACD\n(c) 證明：三角形的中線將三角形分成兩個面積相等的部分",
    solution: "(a) 1:1, (b) 2:3, (c) 見中線面積證明",
    explanation: "三角形內部線段對面積分割的影響。",
    hint: "同高三角形的面積比等於底邊比。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) △ABD 和 △ACD 有相同的高（A 到 BC 的距離）",
      "BD = DC（D 為中點），所以面積比 = 1:1",
      "(b) 同樣有相同的高",
      "面積比 = 底邊比 = BD:DC = 2:3",
      "(c) 中線連接頂點和對邊中點",
      "將三角形分成底邊相等的兩個三角形",
      "因此面積相等"
    ]
  },
  {
    id: "M04_15_003",
    topicId: "M04_15",
    question: "平行線與面積比例：\n(a) 在△ABC 中，DE ∥ BC，D 在 AB 上，E 在 AC 上，若 AD:DB = 1:2，求 S△ADE : S△ABC\n(b) 證明：平行於三角形一邊的直線截得的小三角形與原三角形面積比等於對應邊比的平方\n(c) 應用：梯形 ABCD 中，AB ∥ CD，AB = 6，CD = 9，求△ABC 與△ACD 的面積比",
    solution: "(a) 1:9, (b) 見平行線面積證明, (c) 2:3",
    explanation: "平行線產生的相似三角形的面積關係。",
    hint: "平行線產生相似三角形，面積比等於相似比的平方。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) AD:AB = 1:3（因為 AD:DB = 1:2）",
      "△ADE ∽ △ABC，相似比 = 1:3",
      "面積比 = (1:3)² = 1:9",
      "(b) 平行線保證 △ADE ∽ △ABC",
      "相似比 = AD/AB = AE/AC",
      "面積比 = (相似比)²",
      "(c) △ABC 和 △ACD 有相同頂點 A",
      "底邊比 = BC:CD，需要更多信息確定"
    ]
  },
  {
    id: "M04_15_004",
    topicId: "M04_15",
    question: "角平分線與面積比例：\n(a) 在△ABC 中，AD 為∠BAC 的角平分線，證明：S△ABD : S△ACD = AB : AC\n(b) 利用面積比證明角平分線定理：BD : DC = AB : AC\n(c) 應用：在△ABC 中，AB = 6，AC = 8，AD 為角平分線，求△ABD 與△ACD 的面積比",
    solution: "(a) 見角平分線面積證明, (b) 見角平分線定理證明, (c) 3:4",
    explanation: "角平分線對三角形面積分割的特殊性質。",
    hint: "角平分線到兩邊的距離相等。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 設 AD 到 AB、AC 的距離分別為 h₁、h₂",
      "因為 AD 是角平分線，所以 h₁ = h₂ = h",
      "S△ABD = (1/2) × AB × h，S△ACD = (1/2) × AC × h",
      "面積比 = AB : AC",
      "(b) 由面積比 = 底邊比，得 BD : DC = AB : AC",
      "(c) 面積比 = AB : AC = 6 : 8 = 3 : 4"
    ]
  },
  {
    id: "M04_15_005",
    topicId: "M04_15",
    question: "複雜圖形的面積比例：\n(a) 在平行四邊形 ABCD 中，E 為 BC 中點，F 為 CD 中點，求 S△AEF : S□ABCD\n(b) 在正方形 ABCD 中，E、F、G、H 分別為各邊中點，求正方形 EFGH 與原正方形的面積比\n(c) 設計一個面積分割的綜合問題",
    solution: "(a) 3:8, (b) 1:2, (c) 見設計問題",
    explanation: "複雜圖形中面積比例的計算方法。",
    hint: "將複雜圖形分解成基本圖形進行計算。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 利用坐標法或面積分割法",
      "將△AEF 的面積表示為平行四邊形面積的分數",
      "通過計算得到比例 3:8",
      "(b) 正方形 EFGH 是原正方形旋轉 45° 並縮放的結果",
      "邊長比 = 1:√2，面積比 = 1:2",
      "(c) 設計問題：在△ABC 中，D、E、F 分別為三邊中點，",
      "求△DEF 與△ABC 的面積比"
    ]
  },
  {
    id: "M04_15_006",
    topicId: "M04_15",
    question: "面積比例的實際應用：\n(a) 在土地測量中，如何利用面積比例計算不規則地塊面積？\n(b) 在建築設計中，如何利用面積比例優化空間利用？\n(c) 探討面積比例在藝術設計中的美學應用",
    solution: "(a) 見測量應用, (b) 見建築應用, (c) 見藝術應用",
    explanation: "面積比例關係在實際問題中的應用。",
    hint: "面積比例提供了定量分析幾何關係的工具。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 土地測量應用：",
      "將不規則地塊分割成規則圖形",
      "利用相似三角形和面積比例計算",
      "GPS 測量結合幾何計算",
      "(b) 建築設計應用：",
      "房間面積分配的比例關係",
      "採光面積與總面積的比例",
      "功能區域的面積優化",
      "(c) 藝術設計應用：",
      "黃金比例在面積分割中的應用",
      "視覺平衡與面積比例關係",
      "構圖中的面積對比效果"
    ]
  }
]; 